{
  "sections": [
    {
      "label": "Urbanicity",
      "segments": [
        {
          "id": "9092523a-0784-1f44-dda0-9f6ef3bd7507",
          "name": "City",
          "weighting": "us_urban_adults"
        },
        {
          "id": "afdfc8e8-8b79-0214-b9c8-fe061be57488",
          "name": "Suburbs",
          "weighting": "us_suburban_adults"
        },
        {
          "id": "8e5a3175-757f-6024-710d-f85f0e183602",
          "name": "Rural Area",
          "weighting": "us_rural_adults"
        }
      ]
    },
    {
      "label": "States",
      "segments": [
        {
          "id": "9f323380-e00d-74c4-41ef-4f1cb079c236",
          "name": "Arizona",
          "weighting": "Arizona"
        },
        {
          "id": "c4c756b0-e8c1-0274-8d32-30605f28ff01",
          "name": "California",
          "weighting": "California"
        },
        {
          "id": "f3210c3e-66aa-5044-79f3-369d2efeb2d2",
          "name": "Colorado",
          "weighting": "Colorado"
        },
        {
          "id": "3ac23930-46bd-2144-31eb-8c5867d5b86b",
          "name": "Florida",
          "weighting": "Florida"
        },
        {
          "id": "87fa50e2-616c-0974-2d05-2297e1747a61",
          "name": "Georgia",
          "weighting": "Georgia"
        },
        {
          "id": "6bc59d13-63b7-8124-6de6-b556860cdb44",
          "name": "Illinois",
          "weighting": "Illinois"
        },
        {
          "id": "81c29721-3946-eac4-7dd6-effd70c4bd2d",
          "name": "Massachusetts",
          "weighting": "Massachusetts"
        },
        {
          "id": "355e637c-467d-e4e4-6d39-a800de81d055",
          "name": "Michigan",
          "weighting": "Michigan"
        },
        {
          "id": "5d88fd17-54d9-6a94-a53c-ebe4c2a47552",
          "name": "Minnesota",
          "weighting": "Minnesota"
        },
        {
          "id": "734e8b72-fdc0-33b4-292c-e8e6456c070f",
          "name": "New York",
          "weighting": "new_york"
        },
        {
          "id": "431a00a9-542b-4514-a9f8-fc37a63e6b16",
          "name": "Ohio",
          "weighting": "ohio"
        },
        {
          "id": "23b68973-59dc-3c24-fd1a-58e4f54e9039",
          "name": "Pennsylvania",
          "weighting": "pennsylvania"
        },
        {
          "id": "bb96a9e0-e600-e2a4-1506-3a9ff1b5321a",
          "name": "Texas",
          "weighting": "Texas"
        },
        {
          "id": "a35b6c23-8495-e1b4-c1ac-a7ec1689c794",
          "name": "Washington",
          "weighting": "Washington"
        }
      ]
    },
    {
      "label": "Metros & Cities",
      "segments": [
        {
          "id": "40969e51-8153-1d74-d1bd-4dfc7010031a",
          "name": "Atlanta",
          "weighting": "Atlanta"
        },
        {
          "id": "dafd250f-fe61-2c94-2595-953a7a77cf7b",
          "name": "Boston",
          "weighting": "Boston_MA-Manchester_NH"
        },
        {
          "id": "86677bec-6b26-6af4-e552-acafbdda21db",
          "name": "Chicago",
          "weighting": "Chicago"
        },
        {
          "id": "79d01827-1f69-81a4-3920-95a850b72bc0",
          "name": "Cleveland",
          "weighting": "Cleveland-Akron-Canton"
        },
        {
          "id": "72b449e5-3b43-7954-996a-5e998fe2173c",
          "name": "Dallas",
          "weighting": "Dallas-Forth Worth"
        },
        {
          "id": "58c19b23-0685-4844-ddc9-e644d30727dc",
          "name": "Denver",
          "weighting": "Denver CO"
        },
        {
          "id": "6edd14bc-79aa-c594-415b-62e773683c60",
          "name": "Detroit",
          "weighting": "Detroit MI"
        },
        {
          "id": "60134378-2a55-29f4-5d38-23e6a8a51b5c",
          "name": "Houston",
          "weighting": "Houston TX"
        },
        {
          "id": "826a23c8-7e18-1e64-1907-c602409b97c9",
          "name": "Los Angeles",
          "weighting": "Los_Angeles_CA"
        },
        {
          "id": "42bb45fb-451b-68e4-c12b-9aeb9c43f686",
          "name": "Miami",
          "weighting": "Miami-Ft._Lauderdale_FL"
        },
        {
          "id": "c5ed3478-dd0a-1954-1d01-4cbe4729224a",
          "name": "Minneapolis",
          "weighting": "Minneapolis-St._Paul_MN"
        },
        {
          "id": "1a016cc8-7dfc-9654-9d54-6211f1b47535",
          "name": "New York City",
          "weighting": "New_York_Market"
        },
        {
          "id": "6fc653a2-40c7-4523-8743-4f57886b81f3",
          "name": "Orlando-Daytona Beach-Melbourne",
          "weighting": "Orlando-Daytona_Beach-Melbourne_FL"
        },
        {
          "id": "7dbc76ee-7bc5-6184-4928-92da903c0611",
          "name": "Philadelphia",
          "weighting": "Philadelphia_PA"
        },
        {
          "id": "2112dd45-4e1e-d174-cd7b-593273cb4054",
          "name": "Phoenix",
          "weighting": "Phoenix AZ"
        },
        {
          "id": "8601715e-112d-4c14-69d9-69b22a881baf",
          "name": "Pittsburgh",
          "weighting": "Pittsburgh_PA"
        },
        {
          "id": "dd092401-2ee5-47eb-9018-c1a00fc701be",
          "name": "Sacramento-Stockton-Modesto",
          "weighting": "Sacramento-Stockton-Modesto_CA"
        },
        {
          "id": "034467ce-0c3f-e344-4d79-c446b0a878b2",
          "name": "San Francisco",
          "weighting": "San_Francisco-Oakland-San_Jose_CA"
        },
        {
          "id": "b74ba233-c736-8584-9dab-23e092512cde",
          "name": "Seattle",
          "weighting": "Seattle-Tacoma_WA"
        },
        {
          "id": "7977d67c-4c84-c5c4-65aa-e0a643a42f69",
          "name": "Tampa",
          "weighting": "Tampa-St_Petersburg-Sarasota"
        },
        {
          "id": "4c4a9f9d-e551-4284-9966-90fcc0ec0211",
          "name": "Washington, DC",
          "weighting": "Washington_DC_Hagerstown_MD"
        }
      ]
    }
  ]
}
